interface Column {
  title: string;
  key: string;
  sortable?: boolean;
  property?: string; // Maps the TableRow key to a property of the underlying data
}
interface TableRow {
  id: string;
  data: any;
  formatted: any;
  warning?: boolean; // Optional property to indicate if the row should have a warning background color
  warningMessage?: string; // Optional property to indicate if the row should have a warning background color
  selectable?: boolean; // Optional property to indicate if the row can be selected
  selectableTooltip?: string; // Optional tooltip message when row is not selectable
  actions: {
    [key: string]: {
      icon: string;
      handler: (item: TableRow, done?: () => void) => Promise<void>;
    };
  };
}

interface FilterConfig {
  key: string;
  label?: string;
  type?: "select" | "autocomplete" | "range" | "date";
  placeholder?: string;
  multiple?: boolean;
  clearable?: boolean;
  toMany?: boolean;
  optionStore?: EntityTypeName;
  options?:
    | { title: string; value: null | string | number | boolean }[]
    | ((
        itemsOrFormValues?: any,
      ) => { title: string; value: null | string | number | boolean }[])
    | ((
        itemsOrFormValues?: any,
      ) => Promise<
        { title: string; value: null | string | number | boolean }[]
      >);
  search?: (
    search?: string,
  ) => Promise<{ title: string; value: null | string | number | boolean }[]>;
  valueMapping?: {
    title: string;
    value?: string | number | boolean;
  };
  min?: number;
  max?: number;
  step?: number;
  defaultValue?: any;
}

export enum FilterValue {
  EMPTY = "EMPTY_FILTER_VALUE",
  IS_EMPTY = "IS_EMPTY_FILTER_VALUE",
  NOT_EMPTY = "NOT_EMPTY_FILTER_VALUE",
}

interface Filter extends FilterConfig {
  value: any;
}

interface TableDefaultAction {
  label: string;
  icon: string;
  color?: string;
  handler:
    | ((done?: () => void) => Promise<void>)
    | ((done?: () => void) => void);
}

interface TableMultiItemsAction {
  label: string;
  icon: string;
  color?: string;
  handler:
    | ((ids: string[], done?: () => void) => Promise<void>)
    | ((ids: string[], done?: () => void) => void);
}

interface TableConfig {
  entityName: EntityTypeName;
  store: any;
  key: string;
  columns: Column[];
  filtersConfig?: FilterConfig[] | Filter[];
  order?: {
    by: string;
    asc: boolean;
  };
  toTableRow: (item: any, done?: () => void) => TableRow;
  defaultActions: {
    [key: string]: TableDefaultAction;
  };
  multiItemsActions: {
    [key: string]: TableMultiItemsAction;
  };
  hideFilterBar?: boolean;
  hideSelect?: boolean;
  disableSearch?: boolean;
  rowClickHandler?: (event: Event, row: { item: TableRow }) => void;
}
